export function getPaymentMethodName(method) {
  switch (method) {
    case "CREDIT_CARD":
      return "Credit Card";
    case "SAHABAT_SAMPOERNA":
      return "Sahabat Sampoerna";
    case "LINKAJA":
      return "LinkAja";
    case "SHOPEEPAY":
      return "ShopeePay";
    case "PAYPAL":
      return "PayPal";
    case "NO_METHOD":
      return "No Method";
    case "MANUAL":
      return "Manual";
    case "THIRDPARTY":
      return "Thirdpaty";
    default:
      return method;
  }
}
